import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Box,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import {
  CmpButton,
  CmpSelectBox,
  CmpTextField,
  CmpTextFieldEnter,
} from "../../../Component/Common/ToolBox/ToolBox";
import { WmsPoPhysicalStockCountDetailTblCard } from "./WmsPoPhysicalStockCountDetailTblCard";
import {
  ErrorMsgDetail,
  fItemCodeDependency,
  fValidationDetail_Client,
  GetAccordionRow,
  GetItemFullSearchArr,
  GetUnitArr,
} from "../WmsPoPhysicalStockCountAction";
import { useCallback, useState } from "react";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  Get_ToggleDropDown_binsearch_Load,
} from "../../../Utility/Utilitys";
import { confirmAlert } from "react-confirm-alert";
import { fExecuteAPI } from "../../../Server/Apis";
import {
  vRdxUserInfo,
  WmsPoPhysicalStockCountRo,
} from "../../../Redux/roStore";
import moment from "moment";
import { useSelector } from "react-redux";

export default function WmsContentCardWrapper({ headerList = [] }) {
  let timeout = null;
  const vRdxHead = useSelector(
    (state) => state.SliceWmsPoPhysicalStockCount.value.HeadObj
  );
  const sRoundingVal = 4;
  const [sGC_Toggle_Head_BinName_GridData, setGC_Toggle_Head_BinName_GridData] =
    useState([]);
  const [
    sGC_Toggle_Head_BinName_ToggleDropDowm,
    setGC_Toggle_Head_BinName_ToggleDropDowm,
  ] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [rowData, setRowData] = useState({});
  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);
  const [sBufferObj, setBufferObj] = useState({
    B_Srno: 0, // int
    B_CardId: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_BinCode: "",
    B_BinName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
  });
  let vBufferObjInit = {
    B_Srno: 0, // int
    B_CardId: "",
    B_Itmcd: "",
    B_ItmName: "",
    B_BinCode: "",
    B_BinName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
  };
  const fClearErrorMsg = () => {
    setErrorMsgDetail(ErrorMsgDetail);
  };

  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const sEnterKeyObj = {
    key: "Enter",
  };
  const fContent_Focus = (e) => {
    if (Number(e.target.value) === 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value === "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };
  const fCardId = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_CardId: e.target.value,
    }));
    fCardId_BackSpace_Clear();
  };
  const fCardId_BackSpace_Clear = () => {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: "",
      B_ItmName: "",
      B_Unit: "",
      B_PackQty: 0,
      B_BaseQty: 0,
      B_Packing: 0,
    }));
    setUnit([]);
  };
  const fCardIdEnter = async (e) => {
    if (e.key === "Enter") {
      if (sBufferObj.B_CardId === "") {
        fAlertToast("FAILED", "CardID is empty");
      } else {
        GetCartIDDetail(sBufferObj.B_CardId);
      }
    } else if (e.key === "Backspace") {
      fCardId_BackSpace_Clear();
    }
  };

  const xfGC_Toggle_Head_BinName_Name = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_BinName: e.target.value,
      B_BinCode: "",
    }));
  };
  const xfGC_Toggle_Head_BinName_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_BinName_ToggleDropDowm) {
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setGC_Toggle_Head_BinName_GridData([]);
    } else {
      setGC_Toggle_Head_BinName_ToggleDropDowm(true);
    }
  }, [sGC_Toggle_Head_BinName_ToggleDropDowm]);
  const fGC_Toggle_Head_BinName_onKeyUp = async (e) => {
    // fBinNameKey(e);
    if (e.key === "Enter" || e._reactName === "onClick") {
      if (sBufferObj.B_BinName == "") {
        fAlertToast("FAILED", "BinName is empty");
        return;
      }
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
        sBufferObj.B_BinName,
        "Any",
        "Y",
        vRdxHead.Loc
      );

      if (vExactSearch.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_BinCode: vExactSearch[0].UId,
          B_BinName: vExactSearch[0].Name1,
        }));

        setTimeout(() => {
          const element = document.querySelector(
            '.Mui-expanded [tabindex="104"]'
          );
          element?.focus();
        }, 100);
      } else {
        fAlertToast("FAILED", "Wrong Bin Name");
        fGC_Toggle_Head_BinName_Dropdown_SearchModalKey(e);
      }

      if (sBufferObj.B_BinCode !== "") {
        setTimeout(() => {
          const element = document.querySelector('[tabindex="104"]');
          element?.focus();
        }, 100);
      }
    }
    if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_BinCode: "",
      }));
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_BinName_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      if (sBufferObj.B_BinName !== "") {
        const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
          sBufferObj.B_BinName,
          "Any",
          "N",
          vRdxHead.Loc
        );

        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_BinName_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_BinName_GridData([]);
        }
      }
      xfGC_Toggle_Head_BinName_Toggle();
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  };
  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
  };
  const fQty_Enter = (e) => {
    if (e.key === "Enter") {
      // fSave();
      document.querySelector('.Mui-expanded [name="B_Qty"]')?.blur();
    }
  };
  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue?.PackDesc,
    }));
  };
  const [sUnit, setUnit] = useState([]);

  const GetCartIDDetail = async (xCardId) => {
    const CartBarcodeDetailObj = {
      v_CardID: xCardId,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "BIN_TRANSFER_CARD_ID",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd: CartBarcodeDetail.ResultSet[0].ItmCd,
          B_ItmName: CartBarcodeDetail.ResultSet[0].Name2,
        }));

        let vItemSearchFull = await GetItemFullSearchArr(
          CartBarcodeDetail.ResultSet[0].ItmCd,
          vRdxHead.Loc
        );

        if (vItemSearchFull.length > 0) {
          fItemCodeDependency(
            vItemSearchFull,
            setBufferObj,
            setUnit,
            CartBarcodeDetail.ResultSet[0].Unit
          );
        }
      } else {
        fCardId_BackSpace_Clear();
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else {
      if (!!CartBarcodeDetail?.Message) {
        fAlertToast("FAILED", CartBarcodeDetail?.Message);
      } else {
        fAlertToast("FAILED", CartBarcodeDetail.response.data.message);
      }
    }
  };
  const handleExpand = async (panel, B_ItmCd) => {
    const isExpanded = expanded === panel ? false : panel;
    setExpanded(isExpanded);

    // Fetch data only if not already fetched
    setBufferObj(vBufferObjInit);
    setUnit([]);
    setErrorMsgDetail({
      B_Srno: "",
      B_CardId: "",
      B_Itmcd: "",
      B_ItmName: "",
      B_BinCode: "",
      B_BinName: "",
      B_Qty: "",
      B_Unit: "",
      B_UnitName: "",
      B_PackQty: "",
      B_Packing: "",
      B_BaseQty: "",
    });

    if (isExpanded && (!rowData[B_ItmCd] || !rowData[B_ItmCd].fetched)) {
      const data = await GetAccordionRow({ itemCode: B_ItmCd });

      setRowData((prev) => ({
        ...prev,
        [B_ItmCd]: {
          data,
          fetched: true,
        },
      }));
    }
  };
  const fDetail_Grid_onRowClick = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item.row.B_SrNo,
      B_CardId: item.row.B_CardID,
      B_Itmcd: item.row.B_ItmCd,
      B_ItmName: item.row.ItmName,
      B_BinCode: item.row.B_BinCd,
      B_BinName: item.row.BinName,
      B_Qty: item.row.B_Qty,
    }));
    let currentUnitArr = await GetUnitArr(item.row.B_ItmCd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.B_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue.PackDesc,
    }));
  };
  const fNew = async () => {
    fClearErrorMsg();
    fNewDetail();
  };
  const fNewDetail = async (ItemCd = sBufferObj.B_Itmcd) => {
    setBufferObj(vBufferObjInit);

    setUnit([]);
    document.getElementsByName("B_CardId")[0]?.focus();
    if (!!ItemCd) {
      const data = await GetAccordionRow({ itemCode: ItemCd });
      setRowData((prev) => ({
        ...prev,
        [ItemCd]: {
          data,
          fetched: true, // ✅ add this back!
        },
      }));
    }
  };
  const fDelete = (Srno = sBufferObj.B_Srno, ItemCd = sBufferObj.B_Itmcd) => {
    if (vRdxHead.A_DocStat === "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (Srno === 0) {
      fAlertToast("FAILED", "Item is not selected");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail(Srno, ItemCd);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };
  const fDeleteDetail = async (
    Srno = sBufferObj.B_Srno,
    ItemCd = sBufferObj.B_Itmcd
  ) => {
    let vDeleteSIDetailObj = {
      B_SheetId: vRdxHead.SheetNo,
      B_SrNo: Srno,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await fExecuteAPI(
      "WMPOIPT01_poDelete_GETROW",
      FinalObj
    );

    if (vDeleteSIDetail?.Type?.toUpperCase() === "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail(ItemCd);
    } else if (vDeleteSIDetail?.Type?.toUpperCase() === "FAILED") {
      fAlertToast("FAILED", vDeleteSIDetail?.Status);
    } else {
      fAlertToast("FAILED", vDeleteSIDetail?.response?.data?.Status);
    }
  };
  const fSave = async (ItmCd, Barcode) => {
    clearTimeout(timeout);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      if (vRdxHead?.A_DocStat !== "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxHead?.A_DocStat + " mode"
        );
        return;
      }

      let validationDetil = fValidationDetail_Client(
        sBufferObj,
        setErrorMsgDetail
      );

      if (!validationDetil) return;

      if (ItmCd.trim() == sBufferObj.B_Itmcd.trim()) {
        fSaveHead(fNewDetail, sBufferObj);
      } else {
        fAlertToast(
          "FAILED",
          `Item code ${sBufferObj?.B_Itmcd} not matched with header item code ${ItmCd},barcode (${Barcode})`
        );
        return;
      }
    }, 500);
  };
  const fSaveHead = async (fNewDetail, sBufferObj) => {
    const vRdxUserInfoObj = vRdxUserInfo();
    const { HeadObj } = WmsPoPhysicalStockCountRo(); //xSave False means Post
    let vSaveSIHeadObj = {
      A_POTyp: HeadObj.PoType,
      A_PONo: HeadObj.PoNo,
      A_SheetId: HeadObj.SheetNo,
      A_Loc: HeadObj.Loc,
      A_Date: moment(HeadObj.Date).format("MM/DD/YYYY"),
      A_Status: HeadObj.A_DocStat,
      A_RefNo: HeadObj.ReferenceNo,
      A_UserCd: HeadObj.PDTUserCode,
      UserCd: vRdxUserInfoObj.UserID,
      IP: vRdxUserInfoObj.IP,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
    const vSaveSIHead = await fExecuteAPI(
      "WMPOIPT01_poSaveHead_GETROW",
      FinalObj
    );
    if (vSaveSIHead?.Type?.toUpperCase() === "SUCCESS") {
      fSaveDetail(sBufferObj, fNewDetail);
    } else if (vSaveSIHead?.Type?.toUpperCase() === "FAILED") {
      fAlertToast("FAILED", vSaveSIHead.Status);
    } else {
      fAlertToast(
        "FAILED",
        !!vSaveSIHead.response.data.message
          ? vSaveSIHead?.response?.data?.message
          : "Fail to Save Head"
      );
    }
  };

  const fSaveDetail = async (sBufferObj, fNewDetail) => {
    const { HeadObj } = WmsPoPhysicalStockCountRo();

    let vSaveSIDetailObj = {
      B_SheetId: HeadObj.SheetNo,
      B_SrNo: sBufferObj.B_Srno,
      B_CardID: sBufferObj.B_CardId,
      B_BinCd: sBufferObj.B_BinCode,
      B_ItmCd: sBufferObj.B_Itmcd.trim(),
      B_Qty: sBufferObj.B_Qty,
      B_Unit: sBufferObj.B_Unit,
      B_BinName: sBufferObj.B_BinName,
      B_LocCd: HeadObj.Loc,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIDetailObj);
    const vSaveSIDetail = await fExecuteAPI(
      "WMPOIPT01_poSaveDetail_GETROW",
      FinalObj
    );
    if (vSaveSIDetail?.Type?.toUpperCase() === "SUCCESS") {
      fNewDetail();
      fAlertToast("SUCCESS", "Successfully Saved");
    } else if (vSaveSIDetail?.Type?.toUpperCase() === "FAILED") {
      fAlertToast("FAILED", vSaveSIDetail?.Status);
    } else {
      fAlertToast("FAILED", vSaveSIDetail?.response?.data?.Status);
    }
  };
  return (
    <Box>
      {Array.isArray(headerList) && headerList.length > 0 ? (
        headerList.map((item, index) => (
          <Accordion
            key={item.B_ItmCd}
            expanded={expanded === `panel-${index}`}
            onChange={() => handleExpand(`panel-${index}`, item?.B_ItmCd)}
            sx={{ mb: 1, borderRadius: 2, boxShadow: 2 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                backgroundColor: "#e6f0fb",
                borderBottom: "1px solid #90caf9",
                borderTopLeftRadius: 2,
                borderTopRightRadius: 2,
                // gap: 2,
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Grid container spacing={0.1}>
                {/* Line 1: Item Name + BarCode */}
                <Grid item xs={12} sm={5}>
                  <Typography
                    sx={{
                      fontSize: "0.85rem",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {item?.Item_Name}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Typography
                    sx={{
                      fontSize: "0.85rem",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {item?.BarCode}
                  </Typography>
                </Grid>

                {/* Line 2: Department + Qty */}
                <Grid item xs={8} sm={3}>
                  <Typography
                    sx={{
                      fontSize: "0.85rem",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {item?.Department}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={1}>
                  <Typography
                    align="right"
                    sx={{
                      fontSize: "0.85rem",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {rowData[item.B_ItmCd]?.fetched &&
                    Array.isArray(rowData[item.B_ItmCd].data)
                      ? rowData[item.B_ItmCd].data.reduce(
                          (acc, cur) => acc + parseFloat(cur.B_Qty || 0),
                          0
                        )
                      : parseFloat(item?.Qty || 0)}
                  </Typography>
                </Grid>

                {/* Line 3: Asile */}
                {/* <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.75rem",
                      color: "#555",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    Asile: {item?.Asile}
                  </Typography>
                </Grid> */}
              </Grid>
            </AccordionSummary>

            <AccordionDetails
              className="p-2"
              sx={{ backgroundColor: "#f9f9f9" }}
            >
              <form
                className="Wms-inbound-grn-content mt-4"
                id="WmsStockAdjustmentContent"
              >
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  {/* <Grid item xs={4}>
                    <CmpTextField
                      xLabelText={"Sr.No"}
                      xVariant={"standard"}
                      xValue={sBufferObj.B_Srno}
                      xType={"text"} // text/number/password
                      xName={"B_Srno"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={
                        sErrorMsgDetail.B_Srno === ""
                          ? false
                          : true
                      }
                      xErrorMessage={sErrorMsgDetail.B_Srno}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6} md={3}>
                    <CmpTextFieldEnter
                      xLabelText={"Card ID"}
                      xVariant={"standard"}
                      xValue={sBufferObj.B_CardId}
                      xType={"text"} // text/number/password
                      xName={"B_CardId"}
                      xReadOnly={false}
                      xOnChange={fCardId}
                      xError={sErrorMsgDetail.B_CardId === "" ? false : true}
                      xErrorMessage={sErrorMsgDetail.B_CardId}
                      xtabIndex={"101"}
                      xOnKeyUp={fCardIdEnter}
                      xOnEnter={(e) => {
                        fCardIdEnter(sEnterKeyObj);
                      }}
                      xSmShow={!!vMediaQuery}
                    />
                  </Grid>
                  {/* <Grid item xs={4}>
                    <CmpTextField
                      xLabelText={"Item Code"}
                      xVariant={"standard"}
                      xValue={sBufferObj.B_Itmcd}
                      xType={"text"} // text/number/password
                      xName={"B_Itmcd"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={
                        sErrorMsgDetail.B_Itmcd === ""
                          ? false
                          : true
                      }
                      xErrorMessage={sErrorMsgDetail.B_Itmcd}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <CmpTextField
                      xLabelText={"Item Name"}
                      xVariant={"standard"}
                      xValue={sBufferObj?.B_ItmName}
                      xOnChange={contentProps.fItemName}
                      xReadOnly={true}
                      xType={"text"}
                      xName={"B_ItmName"}
                      xError={
                        sErrorMsgDetail.B_ItmName === ""
                          ? false
                          : true
                      }
                      xErrorMessage={sErrorMsgDetail.B_ItmName}
                      xtabIndex={"102"}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <CmpTextField
                      xLabelText={"Bin No"}
                      xVariant={"standard"}
                      xValue={sBufferObj.B_BinCode}
                      xType={"text"} // text/number/password
                      xName={"B_BinCode"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={
                        sErrorMsgDetail.B_BinCode === ""
                          ? false
                          : true
                      }
                      xErrorMessage={sErrorMsgDetail.B_BinCode}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6} md={3}>
                    <CmpTextFieldEnter
                      xtabIndex="103"
                      xLabelText={"Bin Name"}
                      xVariant={"standard"}
                      xValue={sBufferObj.B_BinName}
                      xOnChange={xfGC_Toggle_Head_BinName_Name}
                      xOnKeyUp={fGC_Toggle_Head_BinName_onKeyUp}
                      xReadOnly={false}
                      xType={"text"}
                      xName={"GC_Toggle_Head_BinName_Name"}
                      xError={sErrorMsgDetail.B_BinName === "" ? false : true}
                      xErrorMessage={sErrorMsgDetail.B_BinName}
                      xOnEnter={(e) => {
                        fGC_Toggle_Head_BinName_onKeyUp(sEnterKeyObj);
                      }}
                      xSmShow={!!vMediaQuery}
                    />
                  </Grid>
                  <Grid item xs={4} sm={2} md={1}>
                    <CmpTextField
                      xLabelText={"Qty"}
                      xVariant={"standard"}
                      xtabIndex={"104"}
                      xValue={sBufferObj.B_Qty}
                      xType={"number"} // text/number/password
                      xName={"B_Qty"}
                      xReadOnly={false}
                      xOnChange={fQty}
                      xError={sErrorMsgDetail.B_Qty === "" ? false : true}
                      xErrorMessage={sErrorMsgDetail.B_Qty}
                      xOnKeyUp={fQty_Enter}
                      xonFocus={(e) => {
                        fContent_Focus(e);
                      }}
                      xonBlur={fContent_Blur}
                    />
                  </Grid>
                  <Grid item xs={8} sm={3} md={2}>
                    <CmpSelectBox
                      xtabIndex={"105"}
                      xLabelText="Unit"
                      xVariant={"standard"}
                      xValue={sBufferObj.B_Unit}
                      xOnChange={fUnit}
                      xName={"unit"}
                      xData={sUnit}
                      xValueMember={""}
                      xDispalyMember={""}
                      xError={sErrorMsgDetail.B_Unit === "" ? false : true}
                      xErrorMessage={sErrorMsgDetail.B_Unit}
                      xDisable={false}
                    />
                  </Grid>
                  <Grid item xs={6} sm={2} md={2}>
                    <CmpTextField
                      xLabelText={"Packing"}
                      xVariant={"standard"}
                      xtabIndex={"107"}
                      xValue={sBufferObj.B_Packing}
                      xType={"text"} // text/number/password
                      xName={"B_Packing"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={sErrorMsgDetail.B_Packing === "" ? false : true}
                      xErrorMessage={sErrorMsgDetail.B_Packing}
                    />
                  </Grid>
                  <Grid item xs={6} sm={2} md={1}>
                    <CmpTextField
                      xLabelText={"Base Qty"}
                      xVariant={"standard"}
                      xtabIndex={"107"}
                      xValue={sBufferObj.B_BaseQty}
                      xType={"text"} // text/number/password
                      xName={"B_BaseQty"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={sErrorMsgDetail.B_BaseQty === "" ? false : true}
                      xErrorMessage={sErrorMsgDetail.B_BaseQty}
                    />
                  </Grid>
                </Grid>
              </form>

              <Grid
                container
                className="my-2"
                spacing={{ xs: 1, sm: 1, md: 0 }}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Grid item xs={6} sm={4} md={2.2} lg={2.2} textAlign={"center"}>
                  <CmpButton
                    xbtnName="New"
                    xOnClick={fNew}
                    xVariant="contained"
                    xDisabled={false}
                    xSize="small"
                    xId={"IdNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={6} sm={4} md={2.2} lg={2.2}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={() => {
                      fSave(item.B_ItmCd, item.BarCode);
                    }}
                    xVariant="contained"
                    xDisabled={vRdxHead.A_DocStat !== "ENTER"}
                    xSize="small"
                    xId={"IdSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                {/* <Grid item xs={4} sm={4} md={2.2} lg={2.2}>
                  <CmpButton
                    xbtnName="Delete"
                    xOnClick={fDelete}
                    xVariant="contained"
                    xDisabled={vRdxHead.A_DocStat !== "ENTER"}
                    xSize="small"
                    xId="IdDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid> */}
                {/* <Grid item xs={4} sm={4} md={2.2} lg={2.2}>
                <CmpButton
                  xbtnName="Approve"
                  xOnClick={fApprove}
                  xVariant="contained"
                  xDisabled={vRdxHead.A_DocStat !== "ENTER"}
                  xSize="small"
                  xId={"IdApprove"}
                  xSendIcon={<CheckCircleOutlineRoundedIcon />}
                />
              </Grid>
              <Grid
                item
                xs={4}
                sm={4}
                md={2.2}
                lg={2.2}
                className="xs-screen-hide"
              >
                <CmpButton
                  xbtnName="Print"
                  xOnClick={() => fPrint(sTrnTyp)}
                  xVariant="contained"
                  xDisabled={false}
                  xSize="small"
                  xId="IdPrint"
                  xSendIcon={<LocalPrintshopIcon />}
                />
              </Grid> */}
              </Grid>
            </AccordionDetails>
            <AccordionDetails className="p-2">
              {rowData[item.B_ItmCd]?.fetched ? (
                <WmsPoPhysicalStockCountDetailTblCard
                  data={rowData[item.B_ItmCd].data}
                  onClick={fDetail_Grid_onRowClick}
                  onDelete={(item) => fDelete(item.B_SrNo, item.B_ItmCd)}
                  vRdxHead={vRdxHead}
                />
              ) : null}
            </AccordionDetails>
          </Accordion>
        ))
      ) : (
        <Typography></Typography>
      )}
    </Box>
  );
}
